/**
 * PDP accordion page-jump fix.
 *
 * Impact sticks `.product-info` on desktop. Opening a tall accordion (e.g.
 * Description on Advanced Dental Powder) makes that sticky column taller than
 * the viewport, and the browser repositions it mid-animation so the whole buy
 * column jumps. Hold the clicked summary at its pre-click viewport Y for the
 * duration of Impact's height animation (~250ms) so the page stays put.
 */
(function () {
  var ANIM_MS = 320;

  function onSummaryClick(event) {
    var summary = event.target.closest(
      '.template-product .product-info details.accordion > summary'
    );
    if (!summary) return;

    var topBefore = summary.getBoundingClientRect().top;
    var start = performance.now();

    function pin() {
      var delta = summary.getBoundingClientRect().top - topBefore;
      if (Math.abs(delta) > 0.5) {
        window.scrollBy(0, delta);
      }
      if (performance.now() - start < ANIM_MS) {
        requestAnimationFrame(pin);
      }
    }

    requestAnimationFrame(pin);
  }

  document.addEventListener('click', onSummaryClick, true);
})();
